import React, { useState, useEffect } from 'react';
import {
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button
} from '@mui/material';
import axios from '../utils/axiosConfig';

const EditGroupForm = ({ group, onSubmit, onCancel }) => {
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');

    // Set initial values when group data is available
    useEffect(() => {
        if (group) {
            setName(group.name || '');
            setDescription(group.description || '');
        }
    }, [group]);

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit({
            name: name.trim(),
            description: description.trim()
        });
    };

    return (
        <>
            <DialogTitle>Edit Group</DialogTitle>
            <DialogContent>
                <TextField
                    autoFocus
                    margin="dense"
                    label="Group Name"
                    fullWidth
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                />
                <TextField
                    margin="dense"
                    label="Description"
                    fullWidth
                    multiline
                    rows={3}
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onCancel}>Cancel</Button>
                <Button 
                    onClick={handleSubmit} 
                    color="primary"
                    disabled={!name.trim()}
                >
                    Save Changes
                </Button>
            </DialogActions>
        </>
    );
};

export default EditGroupForm;
